/**
 * 呼び出し元画面の入力情報を格納するVO
 */
export class KYMW0D00InputModel {
  // 画面ＩＤ
  public dispId: string = <string>'';
  // データ区分
  public dataDiv: string = <string>'';
  // 正常件数
  public normalNum: number = <number>0;
  // 注意件数
  public attentionNum: number = <number>0;
  // 異常件数
  public abnormalNum: number = <number>0;
  // ＤＢ更新件数
  public updateNum: number = <number>0;
  // 処理件数
  public manageNum: number = <number>0;
}
